import axios, { AxiosResponse } from "axios";

let baseUrl = process.env.REACT_APP_API_URL;

export interface SignInParams{ email: string, password: string }

export interface SignUpParams{
    name: string,
    email: string,
    password: string,
    password_confirmation: string,
    userType: number,
    isActive: boolean,
    canExport: boolean
}

export function signIn(formData:SignInParams) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/signin`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                console.log(response)
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function getAllUser() {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/users/`,
            method: "GET",
            headers: {
                Accept: "application/json"
            }
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function getUser(email:string) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/users/${email}`,
            method: "GET",
            headers: {
                Accept: "application/json"
            }
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function createUser(formData:SignUpParams) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/signup`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: 
                formData
            
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function updateUser(formData:SignUpParams) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/user/update/${formData.email}`,
            method: "PUT",
            headers: {
                Accept: "application/json"
            },
            data: 
                formData
            
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function changePassword(formData: { email: string; currentPassword: string; newPassword: string }) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/auth/change-password`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
        })
        .then((response) => {
            resolve({ response: response.data })
        })
        .catch((err) => {
            console.error(err)
            reject({ error: err })
        });
    });
}

export function deleteUser(email: string) {
    console.log(email)
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/user/delete/${email}`,
            method: "DELETE",
            headers: {
                Accept: "application/json"
            }
        })
        .then((response) => {
            resolve({ response: response.data })
        })
        .catch((err) => {
            console.error(err)
            reject({ error: err })
        });
    });
}

